import React from 'react';
import styles from './Details.module.scss';

import { dateTimeFormat, formatDate } from 'helpers/AppHelpers';

import clsx from 'clsx';

export function Details({ data }) {
  if (!data) return null;

  const {
    status,
    jobNumber,
    jobLocation,
    priority,
    severity,
    taskLocation,
    requesterName,
    requesterEmail,
    requesterPhone,
    openedOn,
    workOrderTaskRequest
  } = data;

  const leftBlock = [
    { label: 'Status', value: status?.displayName || '' },
    { label: 'Job number', value: jobNumber || '' },
    { label: 'Job location', value: jobLocation || '' },
    { label: 'Priority', value: priority?.displayName || '' },
    { label: 'Severity', value: severity?.displayName || '' },
    { label: 'Task location', value: taskLocation || '' }
  ];

  const rightBlock = [
    { label: 'Requester name', value: requesterName || '' },
    { label: 'Requester email', value: requesterEmail || '' },
    { label: 'Requester phone #', value: requesterPhone || '' },
    { label: 'Opened on', value: formatDate(openedOn, dateTimeFormat) }
  ];

  const blocks = [leftBlock, rightBlock];

  return (
    <div className={styles.details}>
      <div className={styles.details__container}>
        {blocks.map((block, blockIndex) => (
          <div key={blockIndex} className={styles.details__block}>
            {block.map(({ label, value }) => (
              <div className={styles.details__row} key={label}>
                <span className={styles.details__label}>{label}:</span>
                <span className={styles.details__value}>{value}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className={styles.details__container}>
        <div className={clsx(styles.details__row, styles.column)}>
          <span className={styles.details__label}>Work order task request:</span>
          <span className={styles.details__value}>{workOrderTaskRequest}</span>
        </div>
      </div>
    </div>
  );
}
